"use client";

import { HomePageQueryResult } from "@/sanity.types";
import TextBlocks from "./TextBlocks";
import ButtonCta from "../../../utils/button-cta/ButtonCta";
import { ROUTES } from "@/app/(site)/_lib/routes";
import { hardcodedContent } from "@/app/(site)/_lib/global-content";
import Lottie from "lottie-react";
import homeAnimation from "@assets/lottie/data.json";

type AboutCompanyProps = {
	moduleData: NonNullable<HomePageQueryResult>["aboutCompanyTexts"];
};

export default function AboutCompany({ moduleData }: AboutCompanyProps) {
	const { texts } = moduleData;

	const totalHeight = `${texts.length * 100}vh`;

	return (
		<section id="aboutCompany" className="content-section mb-16 sm:mb-[8.438rem]" style={{ height: totalHeight }}>
			<div className="sticky top-10">
				<div className="relative flex min-h-[92svh] flex-col justify-center overflow-hidden rounded-lg">
					<div className="grid grid-cols-2 gap-x-5 sm:grid-cols-12">
						<div className="col-span-2 mb-10 sm:col-span-5 md:col-span-4 md:col-start-2 md:mb-0">
							<Lottie animationData={homeAnimation} className="h-[30vh] w-full object-contain sm:h-[50vh]" />
							{/* <div className="text-cap-s mt-5 text-center">video animation placeholder</div> */}
						</div>
						<div className="col-span-2 flex flex-col justify-center sm:col-span-7 sm:col-start-6 md:col-span-5 md:col-start-7">
							<TextBlocks texts={texts} />
							<div className="mt-5 flex sm:mt-[3.125rem]">
								<ButtonCta href={ROUTES.ABOUT} label={hardcodedContent.homePage.moreAboutUs} />
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
	);
}
